import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import Dropzone from 'react-dropzone';
import { Text, Button, i18n, tokens } from '@simplybenefits/sb-ui-library';
import { helpers } from '@simplybenefits/sb-utils';

import * as notifier from "../../../actions/notifier";
import pdfReceiptImage from '../../../assets/pdf.png';

class SubmitReceipt extends PureComponent {
    state = {
        photo: this.props.receiptPhoto
    };

    _selectPicture = (files) => {
        const file = new File([ files[0] ], helpers.cleanFilename(files[0].path), { type: files[0].type });
        const reader = new FileReader();
        reader.readAsDataURL(file); 

        reader.onload = () => {
            this.setState({
                photo: {
                    file,
                    image: reader.result
                }
            });

            this.props.saveData({
                file,
                image: reader.result
            }, 'receiptPhoto');
        };
    };

    _next = () => {
        if (!this.state.photo) {
            this.props.dispatch(notifier.displayError({ verbiage: i18n.t(tokens.labels.claims.providePhotoReceipt) }));
            return;
        }

        this.props.next();
    };

    render() {
        const styles = {
            container: {
                display: 'flex',
                flex: 1,
                height: '100%',
                flexDirection: 'column',
                marginBottom: 5
            },
            details: {
                display: 'flex',
                flex: 1,
                overflow: 'auto',
                flexDirection: 'column',
                marginBottom: 20,
                alignItems: 'center'
            },
            image: {
                height: 300,
                width: 'auto',
                marginLeft: 'auto',
                marginRight: 'auto'
            },
            pdf: {
                width: '70%',
                height: 'auto',
                marginLeft: 'auto',
                marginRight: 'auto'
            }
        };

        let isPDF = false;

        if (this.state.photo && this.state.photo.image) {
            if (this.state.photo.file.type === 'application/pdf') {
                isPDF = true;
            }
        }

        return (
            <div style={ styles.container }>
                <div style={ styles.details }>
                    <Text light mediumLarge margin="10px 0 20px 0">
                        {
                            this.props.type === 'HealthSpending' ?
                                i18n.t(tokens.labels.claims.provideHealthReceipt)
                                :
                                i18n.t(tokens.labels.claims.provideReceipt)
                        }
                    </Text>

                    {
                        this.state.photo && this.state.photo.image && isPDF &&
                            <img alt="Receipt" src={ pdfReceiptImage } style={ styles.pdf } />
                    }

                    {
                        this.state.photo && this.state.photo.image && !isPDF &&
                            <img alt="Receipt" src={this.state.photo.image} style={ styles.image } />
                    }

                    <Dropzone
                        onDrop={(files) => this._selectPicture(files)}
                        accept={{ 
                            "image/png": [ ".png" ],
                            "image/jpeg": [ ".jpeg" ],
                            "image/jpg": [ ".jpg" ],
                            "application/pdf": [ ".pdf" ] 
                        }}
                    >
                        {({ getRootProps, getInputProps }) => (
                            <section>
                                <div id="dropzone" {...getRootProps()}>
                                    <input {...getInputProps()} />
                                    <Button
                                        marginTop={ 2 }
                                        marginBottom={ 2 }
                                        transparent
                                    >
                                        { i18n.t(tokens.buttons['select receipt']) }
                                    </Button>
                                </div>
                            </section>
                        )}
                    </Dropzone>
                </div>

                <Text light tiny>
                    { i18n.t(tokens.labels.claims.claimAgreementScreen2) }
                </Text>

                <Button
                    onClick={ this._next }
                    marginTop={ 2 }
                    color="primary"
                    fullWidth
                    testid="submitclaimimagenext"
                >
                    { i18n.t(tokens.buttons.next) }
                </Button>
            </div>
        );
    }
}

export default connect()(SubmitReceipt);